import React from "react";
import { FilterStatus } from "../../constants";
import { useTranslations } from "../../hooks/useTranslations";
import { Dropdown } from "./Dropdown";
import { MarkAsRead } from "./MarkAsRead";
var OrderedFilterStatuses = [FilterStatus.All, FilterStatus.Unread, FilterStatus.Read];
export var NotificationFeedHeader = _ref => {
  var {
    onMarkAllAsReadClick,
    filterStatus,
    setFilterStatus
  } = _ref;
  var {
    t
  } = useTranslations();
  return /*#__PURE__*/React.createElement("header", {
    className: "rnf-notification-feed__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-feed__selector"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rnf-notification-feed__type"
  }, t("notifications")), /*#__PURE__*/React.createElement(Dropdown, {
    value: filterStatus,
    onChange: e => setFilterStatus(e.target.value)
  }, OrderedFilterStatuses.map(filterStatus => /*#__PURE__*/React.createElement("option", {
    key: filterStatus,
    value: filterStatus
  }, t(filterStatus))))), /*#__PURE__*/React.createElement(MarkAsRead, {
    onClick: onMarkAllAsReadClick
  }));
};
//# sourceMappingURL=NotificationFeedHeader.js.map